import { render, staticRenderFns } from "./DefaultPatientActions.vue?vue&type=template&id=e70c8bc4&"
import script from "./DefaultPatientActions.vue?vue&type=script&lang=js&"
export * from "./DefaultPatientActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports